import b2cAuth from '@virtus/common/auth/sagas/B2CLogin';
import idpAuth from '@virtus/common/auth/sagas/IDPLoginJWT'
import aadAuth from '@virtus/common/auth/sagas/AADLogin';
import { runSagas } from '@virtus/common/sagas/runSagas';
import config from 'src/config';

//let sagas:any[];
/**
 * add all sagas here
 */
 const sagas = [...aadAuth];

//  let useAD = "useAD" in config;
//  if(useAD && config.useAD) {
//    sagas = [...aadAuth];
//  } else {
//    sagas = [...idpAuth];
//  }

/**
 * Call this from createStore to run all sagas as their own root.
 *
 * Will Restart each saga if it catches an error and console.error it
 * This stops one error bubbling to parent and killing all sagas
 *
 * @param sagaMiddleware pass in from redux init
 */
export const runAllSagas = (sagaMiddleware: any) => {
  runSagas(sagaMiddleware, sagas);
};
